import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";

// Components
import { IcomDropdown, Option } from "src/components/icom-dropdown";

// Actionns
import {
  getCallServicesByAderente,
  updateCallConference,
} from "src/store/call/actions";
import { updateCall } from "src/store/call/reducer";

// Components
import IcomBtn from "src/components/icom-btn";
import SidePanel from "./panel";

const PanelUdaInfo = ({
  togglePanel,
  udaInfo,
  servicoId,
  aderenteSlug,
}: {
  togglePanel: Function;
  udaInfo: any;
  servicoId: string;
  aderenteSlug: string;
}) => {
  const { callDetails } = useAppSelector((state) => state.call);
  const dispatch = useAppDispatch();

  // Create mini state
  const [state, setState] = useState<{
    selectedService: string;
    servicesList: Array<Option>;
    submiting: boolean;
    loading: boolean;
  }>({
    selectedService: servicoId,
    servicesList: [],
    submiting: false,
    loading: true,
  });

  // Busca serviços
  useEffect(() => {
    getCallServicesByAderente(aderenteSlug).then((result) => {
      if (result.success) {
        setState((s) => ({
          ...s,
          servicesList: result.data.results.map((service: any) => ({
            id: service.id,
            label: service.nome,
            value: service.id,
            show: service.visivel,
          })),
          loading: false,
        }));
      }
    });
  }, []);

  const editService = async () => {
    if (!callDetails) return false;

    setState((s) => ({ ...s, submiting: true }));

    const result = await updateCallConference(callDetails.id, {
      servico: state.selectedService,
    });

    if (result.success) {
      dispatch(updateCall(result.data));
    }

    return setState((s) => ({ ...s, submiting: false }));
  };

  return (
    <SidePanel panelName="Usuário" toggleAction={togglePanel}>
      {state.loading ? (
        "Carregando..."
      ) : (
        <div className="flex flex-col  h-full">
          <div className="grow overflow-y-auto h-0 gap-6 flex flex-col">
            <div className="gap-3 flex flex-col form-group">
              <label
                className="font-bold text-sm text-neutral-gray-800"
                htmlFor="aderente"
              >
                Alterar serviço
              </label>

              <div className="form-group flex gap-3">
                <IcomDropdown
                  className="flex-1"
                  listOptions={state.servicesList}
                  selectedOption={state.selectedService}
                  onChange={(arg) => {
                    setState((s) => ({ ...s, selectedService: arg.value }));
                  }}
                />
                <IcomBtn
                  disabled={
                    servicoId === state.selectedService || state.submiting
                  }
                  onClick={editService}
                >
                  {state.submiting ? (
                    <span className="loader spinner-1 white"></span>
                  ) : (
                    "Alterar"
                  )}
                </IcomBtn>
              </div>
            </div>
            <div className="gap-3 flex flex-col form-group">
              <label
                className="font-bold text-sm text-neutral-gray-800"
                htmlFor="aderente"
              >
                Aderente
              </label>
              <input
                className="p-3 px-4 rounded-md border text-gray-900 w-full"
                id="aderente"
                type="text"
                value={udaInfo?.aderente.nome}
                disabled
              />
            </div>
            <div className="gap-3 flex flex-col form-group">
              <label
                className="font-bold text-sm text-neutral-gray-800"
                htmlFor="uda_nome"
              >
                Nome
              </label>
              <input
                className="p-3 px-4 rounded-md border text-gray-900 w-full"
                id="uda_nome"
                type="text"
                value={udaInfo?.usuario.nome}
                disabled
              />
            </div>
            <div className="gap-3 flex flex-col form-group">
              <label
                className="font-bold text-sm text-neutral-gray-800"
                htmlFor="uda_email"
              >
                E-mail
              </label>
              <input
                className="p-3 px-4 rounded-md border text-gray-900 w-full"
                id="uda_email"
                type="text"
                value={udaInfo?.usuario.email}
                disabled
              />
            </div>
            <div className="gap-3 flex flex-col form-group">
              <label
                className="font-bold text-sm text-neutral-gray-800"
                htmlFor="uda_telefone"
              >
                Telefone
              </label>
              <input
                className="p-3 px-4 rounded-md border text-gray-900 w-full"
                id="uda_telefone"
                type="text"
                value={udaInfo?.usuario.telefone}
                disabled
              />
            </div>
          </div>
        </div>
      )}
    </SidePanel>
  );
};

export default PanelUdaInfo;
